module.exports = __webpack_public_path__ + "static/media/game-gameinfobutton.ec89a48c.png";